module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/icon--community-ea3ae4c9cd5dbfbe02bdb2f1545b6ede.svg";